import { render, staticRenderFns } from "./InviteMemberForm.vue?vue&type=template&id=a65f7e9e"
import script from "./InviteMemberForm.vue?vue&type=script&lang=ts"
export * from "./InviteMemberForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports